import {action, observable, runInAction} from 'mobx'
import {PaginationProps} from "antd/lib/pagination";
import {Pagination} from "../../../constants/common/Pagination";
import {CouponsApi, CouponsGetListRequest, CouponsGetListResponse} from "../../../swagger";
import {adminApiWrapper} from "../../../common/Api/Admin/adminApiWrapper";
import {CouponsGetListRowForm} from "../../../swagger/api";
import {createApiConfiguration} from "../../../utils/apiFactory";

export class CouponsStore {
  @observable
  public loading: boolean = false;

  @observable.ref
  public list: CouponsGetListRowForm[] = [];

  public pagination: PaginationProps = Pagination.defaultProps;
  public request: CouponsGetListRequest = new CouponsGetListRequest();

  @action
  getList() {
    let api = new CouponsApi(createApiConfiguration());
    this.request.pagination = {current: this.pagination.current!, pageSize: this.pagination.pageSize!};

    this.loading = true;
    return adminApiWrapper(() => {
        return api.getList(this.request).then((res: CouponsGetListResponse) => {
          runInAction(() => {
            this.list = res.list!;
            this.pagination.total = res.total;
            this.loading = false;
          })
        });
      },
      "CouponsGetList"
    );
  }
}


